// Minimal logger utility. In development logs to console, in production is silent
// (or could be wired to Sentry/LogRocket).
const isDev = process.env.NODE_ENV !== 'production';

export const logError = (context, error) => {
  if (isDev) {
    console.error(`[${context}]`, error);
  }
  // In production: integrate Sentry.captureException(error, { tags: { context } })
};

export const logInfo = (context, msg) => {
  if (isDev) {
    console.info(`[${context}]`, msg);
  }
};
